import { assign } from 'xstate5';

import { type OrderingMachineAction } from './ordering-machine.actions.types';
import { orderingMachineLog } from './ordering-machine.logger';

// ─────────────────────────────────────────────────────────────────────────────

const handlePostOrderNotifications: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderNotifications` action.');
};

const handlePostOrderTracking: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderTracking` action.');
};

const clearSharedLineItemAttribution: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `clearSharedLineItemAttribution` action.');
};

const clearBundleAttribution: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `clearBundleAttribution` action.');
};

const handlePostOrderHistory: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderHistory` action.');
};

const handlePostOrderAppReview: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `handlePostOrderAppReview` action.');
};

const navigatePostOrder: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `navigatePostOrder` action.');
};

const storeOrderPostSubmission: OrderingMachineAction = assign({
  orderId({ context, event }) {
    const output = event as { output?: { order?: { id?: string } } };
    return output?.output?.order?.id ?? context.orderId;
  },
});

// ─────────────────────────────────────────────────────────────────────────────

export const OrderingPostOrderActions = {
  storeOrderPostSubmission,
  handlePostOrderNotifications,
  handlePostOrderTracking,
  clearSharedLineItemAttribution,
  clearBundleAttribution,
  handlePostOrderHistory,
  handlePostOrderAppReview,
  navigatePostOrder,
};
